//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'tabBar',
  data () {
    return {
    }
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/components/tabBar.vue